import { render, staticRenderFns } from "./ProjectCartTab.vue?vue&type=template&id=6672defe"
import script from "./ProjectCartTab.vue?vue&type=script&lang=js"
export * from "./ProjectCartTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports